export const environment = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Mexico_City",
  code: "MX",
  currency: "MXN",
  country_code: "+52",
  gateway: {
    base_url: "https://services.mxgrability.rappi.com",
  },
  currencySymbol: "$",
  country: {
    defaultLocale: "es-MX",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/mx/cargo-logos/",
  oAuth: {
    client_id: "C5Ej64OTPM2AV9tpBHwXRMgFB2QIJw0bbPeKDg0v",
    redirect_uri: "https://turbo-wms.rappi.com.mx",
    response_type: "code",
    scope: "all",
    flowName: "GeneralOAuthFlow",
  },
  OAuthGateway: "https://www.rappi.com.mx/login-legacy",
  userToken: "b25f8ac1750c8b2efdfa04128ba2b5bc",
  auth0: {
    domain: "turbo-prod.us.auth0.com",
    clientId: "dcvPUE3iXkiFLpqzIpcCtYXCSd70PLAN",
    redirectUri: "https://turbo-wms.rappi.com.mx",
  },
};
